// App.tsx — Root component for the DOMINUS Operator Console.
//
// Composes AdminAuthGate (II login + allowlist check) with AdminLayout
// (shell + all 9 sections). The gate renders a loading screen, II login
// CTA, denial screen, or the dashboard depending on auth state.

import React from 'react';
import AdminAuthGate from './AdminAuthGate';
import AdminLayout from './AdminLayout';

export default function App(): React.ReactElement {
  return (
    <AdminAuthGate>
      {(auth) => <AdminLayout auth={auth} />}
    </AdminAuthGate>
  );
}
